import { useGetLocationsQuery } from '@features/Location/services/locations';
import { distance } from '@utilities/helpers/geo';
import { useMemo } from 'react';
import useUserPosition from './use-user-position';

const useProvideLocations = (
  orderByDistance = true,
  hideNotOpenLocations = false
) => {
  const { data: locations = [] } = useGetLocationsQuery();
  const { userPosition } = useUserPosition(false);

  return useMemo(() => {
    if (!userPosition || !orderByDistance) {
      return locations;
    }

    const { lat: userLat, lng: userLng } = userPosition;

    const ordered = [...locations].sort(
      ({ coordinates: coordinatesA }, { coordinates: coordinatesB }) => {
        const { x: lngA, y: latA } = coordinatesA;
        const { x: lngB, y: latB } = coordinatesB;

        return (
          distance(userLat, userLng, latA, lngA) -
          distance(userLat, userLng, latB, lngB)
        );
      }
    );

    if (hideNotOpenLocations) {
      return ordered.filter(
        ({ soft_opening }) => new Date(soft_opening) < new Date()
      );
    }

    return ordered;
  }, [locations, userPosition, orderByDistance, hideNotOpenLocations]);
};

export default useProvideLocations;
